module.exports = __webpack_public_path__ + "static/media/coffee_hero_mobile.6ea4fe80.jpg";